function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(2.3315 0 0 2.3315 -25.127 .0018686)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  transform: "translate(-79.223)",
  d: "m96.255 18.094a2.606 2.606 0 0 0 4.671-1.876 10.256 10.256 0 0 0 2.156-0.616l8.137 10.808a2.6072 2.6072 0 1 0 4.166-3.136l-8.137-10.808a10.27 10.27 0 0 0 1.187-1.9 2.607 2.607 0 0 0 3.095-3.971l-4.182-5.555a2.606 2.606 0 0 0-4.671 1.876 10.234 10.234 0 0 0-7.509 5.652 2.608 2.608 0 0 0-3.1 3.972zm9.785-4.343 1.161 1.542-1.389 1.045-1.161-1.538a10.234 10.234 0 0 0 1.389-1.048zm7.785 11.785a0.87 0.87 0 0 1-1.217-0.171l-5.75-7.638 1.389-1.045 5.753 7.637a0.87 0.87 0 0 1-0.175 1.217zm-9.083-23.623a0.87 0.87 0 0 1 1.217 0.172l4.182 5.555a0.8691 0.8691 0 1 1-1.389 1.045l-4.181-5.555a0.87 0.87 0 0 1 0.171-1.217zm-1.272 2.646 3.6 4.788a8.513 8.513 0 0 1-6.943 5.228l-3.6-4.789a8.505 8.505 0 0 1 6.944-5.227zm-9.838 5.718a0.869 0.869 0 0 1 1.217 0.172l4.183 5.551a0.8691 0.8691 0 0 1-1.389 1.045l-4.182-5.555a0.869 0.869 0 0 1 0.172-1.213z"
}));
function SvgHammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammer);
export default __webpack_public_path__ + "static/media/hammer.1355ac4f.svg";
export { ForwardRef as ReactComponent };